<hr class="divider" />

<style lang="scss">
  .divider {
    width: 100%;
    border-width: 1px;
    border-style: solid none none none;
    border-color: $color-light-gray;
  }
</style>
